<script lang="ts">
	import Card from '$lib/components/Card.svelte';
	import Image from '$lib/components/Image.svelte';
	import Section from '$lib/components/Section.svelte';
	import SocialMediaIcon from '$lib/components/SocialMediaIcon.svelte';
	import { projectList, type Project } from './projects';
</script>

{#snippet projectCard(project: Project)}
	<Card class="w-full max-w-2xl">
		<h3 class="inline-block align-middle">
			{project.name}
			{#if project.github}
				<a
					href={project.github}
					target="_blank"
					rel="noopener noreferrer"
					class="ml-2 inline-block text-gray-500 transition-colors duration-100 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300"
				>
					<SocialMediaIcon name="github-filled" class="!h-[0.675em] !w-[0.675em]"></SocialMediaIcon>
				</a>
			{/if}
		</h3>
		<div class="mb-2 block space-y-2 md:mb-3">
			{#if project.note}
				<a
					href={project.note.link}
					target="_blank"
					rel="noopener noreferrer"
					class="external inline-flex items-center-safe gap-1 rounded-md bg-[#ff4700] px-2 py-1 text-sm tracking-tighter text-white no-underline hover:bg-[#ff4700]/90"
				>
					<SocialMediaIcon name="svelte" class="h-4 w-4 sm:!h-3.5 sm:!w-3.5"></SocialMediaIcon>
					<span class="">{project.note.text}</span>
				</a>
			{/if}
		</div>

		<figure class="space-y-2">
			<Image
				class="aspect-video h-full min-h-0 w-full rounded-lg object-cover "
				alt={project.name}
				loading="lazy"
				src={project.image}
				wrapperClass="min-h-0 w-full h-full border-1 overflow-hidden rounded-lg  border-gray-300 dark:border-gray-800"
			/>
			<figcaption class="mb-2">
				<p>{project.description_short}</p>
			</figcaption>
		</figure>
		<hr />
		<div class="flex flex-col">
			<p class="text-gray-600 dark:text-gray-300">Built With</p>
			<div class="flex gap-1 sm:gap-4">
				{#each project.tech as tech}
					<span
						class="inline-flex items-center text-sm tracking-tighter text-gray-700 dark:text-gray-400"
						title={tech.name}
						aria-label={tech.name}
					>
						<SocialMediaIcon name={tech.icon} class="!h-5 !w-5"></SocialMediaIcon>
					</span>
				{/each}
			</div>
		</div>
	</Card>
{/snippet}

<Section>
	<h1>Projects</h1>
	<p>
		This list is only a small selection of my favorite projects I've worked on, be sure to check out
		my <a
			href="https://github.com/snuffyDev"
			target="_blank"
			rel="noopener noreferrer"
			class="external">GitHub</a
		> for more!
	</p>
	<div
		class="grid grid-cols-1 gap-2 space-y-4 sm:mt-2 sm:space-y-0 md:grid-cols-2 md:gap-4 lg:mx-6 lg:mt-4 lg:gap-8"
	>
		{#each projectList as project (project.name)}
			{@render projectCard(project)}
		{/each}
	</div>
</Section>
